// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","312":"component---src-pages-nova-stranka-js"}[chunkId] + "-" + {"223":"f38a6834c957249a6ee7","293":"eeb426b57edc53f72b1e","312":"749f5155eaed39ed18ab"}[chunkId] + ".js";
};